// @flow
import {VehicleFoundEventHandler} from "./handler/VehicleFoundEventHandler";
import {VehicleNotFoundEventHandler} from "./handler/VehicleNotFoundEventHandler";
import {StockInformationFoundEventHandler} from "./handler/StockInformationFoundEventHandler";
import {OrdersFoundEventHandler} from "./handler/OrdersFoundEventHandler";
import type {DmsVehicle} from "./model/vehicle";
import type {StockInformation} from "./model/stockInformation";
import type {DmsOrder, DmsOrders} from "./model/dmsOrders";
import {ConnectionAliveEventHandler} from "./handler/ConnectionAliveEventHandler";
import {OrderFoundEventHandler} from "./handler/OrderFoundEventHandler";
import {OrderErrorEventHandler} from "./handler/OrderErrorEventHandler";


export type EventType =
	"ORDERS_FOUND" |
	"ORDER_FOUND" |
	"ORDER_ERROR" |
	"VEHICLE_FOUND" |
	"VEHICLE_NOT_FOUND" |
	"STOCK_INFORMATION_FOUND" |
	"STOCK_INFORMATION_NOT_FOUND" |
	"DMS_ERROR" |
	"CONNECTION_CLOSED" |
	"CONNECTION_ALIVE" |
	"UNKNOWN";

export type Event = {
	type: EventType
}

export type EventHandler = {
	handles: EventType => boolean,
	handle: Event => void
}

export type OrdersFoundEvent = Event & DmsOrders
export type OrderFoundEvent = Event & DmsOrder
export type VehicleFoundEvent = Event & DmsVehicle
export type StockInformationFoundEvent = Event & StockInformation
export type ConnectionAliveEvent = Event

export const getEventHandlers = (): EventHandler[] => {
	return [
		OrdersFoundEventHandler,
		OrderFoundEventHandler,
		OrderErrorEventHandler,
		VehicleFoundEventHandler,
		VehicleNotFoundEventHandler,
		StockInformationFoundEventHandler,
		ConnectionAliveEventHandler
	];
};

